import React from "react";
import { Link } from "react-router-dom";
import { ClockCounterClockwise, ArrowRight } from "@phosphor-icons/react";

function relativeDay(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const now = new Date();
  const diffMs = now - d;
  const hours = diffMs / 3600000;
  if (hours < 1) return `${Math.max(1, Math.round(diffMs / 60000))}m ago`;
  if (hours < 24) return `${Math.round(hours)}h ago`;

  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDoc = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const daysBack = Math.round((startToday - startDoc) / 86400000);
  if (daysBack === 1) return "yesterday";
  if (daysBack < 7) return `${daysBack}d ago`;
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export function RecentSearches({ items, onPick }) {
  if (!items?.length) return null;
  return (
    <div data-testid="recent-searches" className="mt-6">
      <div className="mb-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
          <ClockCounterClockwise size={14} weight="bold" />
          Recent scans
        </div>
        <Link
          to="/history"
          data-testid="recent-see-all"
          className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-wider text-electric hover:underline"
        >
          See all scans <ArrowRight size={11} weight="bold" />
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((it) => (
          <button
            key={it.id}
            type="button"
            data-testid={`recent-${it.id}`}
            onClick={() => onPick(it)}
            className="group inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1 text-xs text-ink transition-colors hover:border-electric hover:text-electric"
            title={`${it.niche} · ${it.area} · ${it.total || 0} businesses`}
          >
            <span className="font-medium">{it.niche}</span>
            <span className="text-muted-foreground group-hover:text-electric/70">
              · {it.area}
            </span>
            {it.created_at ? (
              <span className="rounded-sm bg-black/5 px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground group-hover:bg-electric-soft group-hover:text-electric">
                {relativeDay(it.created_at)}
              </span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  );
}
